import { BaseQueryParams, Filter } from "../../types/filter";
import {
  BillsQueryParam,
  SomethingWithBills,
  filterBills,
  getBillsFilter,
} from "./commonFilters/billsFilter";
import {
  filterHandlingUnits,
  getHandlingUnitsFilter,
  type HandlingUnitsQueryParam,
  type SomethingWithHandlingUnits,
} from "./commonFilters/handlingUnitsFilter";
import {
  PalletsQueryParam,
  SomethingWithPallets,
  filterPallets,
  getPalletsFilter,
} from "./commonFilters/palletsFilter";
import {
  PiecesQueryParam,
  SomethingWithPieces,
  filterPieces,
  getPiecesFilter,
} from "./commonFilters/piecesFilter";
import {
  SomethingWithWeight,
  WeightQueryParam,
  filterWeight,
  getWeightFilter,
} from "./commonFilters/weightFilter";
import { filterResultHandler, Prefix } from "./utils";

export type SummaryQueryParams =
  | PiecesQueryParam
  | PalletsQueryParam
  | WeightQueryParam
  | BillsQueryParam
  | HandlingUnitsQueryParam;
type SummaryFilters = Record<SummaryQueryParams, string[] | undefined>;
type SomethingWithSummary = SomethingWithBills &
  SomethingWithWeight &
  SomethingWithPallets &
  SomethingWithPieces &
  SomethingWithHandlingUnits;

export const filterSummaryData = <T extends SomethingWithSummary>(
  summaries: T[],
  { pieces, pallets, weight, bills, handlingUnits }: SummaryFilters
): T[] => {
  let result = filterBills(summaries, bills);
  result = filterPieces(result, pieces);
  result = filterHandlingUnits(result, handlingUnits);
  result = filterPallets(result, pallets);
  result = filterWeight(result, weight);

  return filterResultHandler(summaries, result);
};

export const getSummaryFilters = (
  summaries: (param: BaseQueryParams) => SomethingWithSummary[],
  prefix?: Prefix
): Filter[] => [
  getBillsFilter(summaries("bills"), prefix),
  getPalletsFilter(summaries("pallets"), prefix),
  getPiecesFilter(summaries("pieces"), prefix),
  getHandlingUnitsFilter(summaries("handlingUnits"), prefix),
  getWeightFilter(summaries("weight"), prefix),
];
